import React from 'react';
import './App.css';
import TestGeoLocation from "./components/TestGeoLocation";

function App() {
  return (
    <div className="App">
      this is react app
      <TestGeoLocation/>
    </div>
  );
}

export default App;
